const getBodyElement = () => {
  if (window.appRootMountPoint) {
    return window.appRootMountPoint;
  }
  return document.querySelector('body');
};

export default getBodyElement;
